<template>
  <v-layout row wrap>
  <v-flex xs12 md6 px-2 pb-2>
    <v-card class="pa-4">
      <v-flex xs12 pb-3 v-if="err">
        <v-alert :value="true" type="error">{{err}}</v-alert>
      </v-flex>
      <v-flex xs12 pb-3 v-if="success">
        <v-alert :value="true" type="success">{{success}}</v-alert>
      </v-flex>
      <v-form v-model="valid">
        <v-layout row wrap justify-space-between align-center>
          <v-flex xs12>
            <v-autocomplete
              :items="companies"
              :label="$lang.actions.selectCompany"
              v-model="image.companyId"
              item-text="name"
              item-value="id"
              required
              :readonly="isEdit"
              :loading="companyLoading"
              :rules="[v => !!v || `${$lang.errors.missingCompany}`]"
            />
          </v-flex>
          <v-flex xs12>
            <v-text-field
              :label="$lang.labels.imageName"
              v-model="image.name"
              required
              :rules="[v => !!v || `${$lang.errors.missingImageName}`]"
            />
          </v-flex>
          <v-flex xs12>
            <v-select
              :items="labels"
              :label="$lang.actions.selectLabel"
              v-model="image.label"
              required
              :loading="lablesLoading"
              :rules="[v => !!v || `${$lang.errors.missingImageLabel}`]"
            />
          </v-flex>
          <v-flex xs12>
            <v-text-field
              prepend-icon="attach_file"
              single-line
              hide-details
              v-model="filename"
              label="choose_file"
              required
              class="min-w"
              @click="startInput('imageInput')"
              ref="fileTextField" />
            <input style="display: none;" type="file" accept="image/*" ref="imageInput" @change="onFileChange('imageInput', $event)">
          </v-flex>
          <v-flex xs6>
            <v-btn
              :disabled="previewValidation()"
              color="primary"
              class="mx-0 mt-4"
              @click="preview()">
              {{ $lang.actions.preview }}
            </v-btn>
          </v-flex>
          <v-flex xs6>
            <v-checkbox
              color="primary"
              class="ml-3 mt-0"
              :label="$lang.labels.publiclyAvailable"
              v-model="image.publiclyAvailable"
              hide-details
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-space-between align-content-center class="mt-3">
          <v-btn
            flat class="ml-0"
            @click="$router.push({ name: 'images' })">
            <v-icon>keyboard_arrow_left</v-icon>
            {{$lang.actions.close}}
          </v-btn>
          <div>
            <v-btn class="primary" v-if="isEdit" @click="toggleActivate()">
              {{ image.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate }}
            </v-btn>
            <v-btn
              class="primary mx-0"
              :disabled="!valid"
              @click="submit">
              {{ isEdit ? $lang.actions.update : $lang.actions.create}}
            </v-btn>
          </div>
        </v-layout>
      </v-form>
    </v-card>
    <v-dialog v-if="previewModal" v-model="previewModal" max-width="800">
      <preview :data="previewData" :image="image" @close="previewModal = false" />
    </v-dialog>
  </v-flex>
    <v-flex xs12 md6 px-2>
      <v-card class="pa-4" v-if="image.base64Image !== ''">
        <v-img contain :src="image.base64Image" style="width: 50% !important; height: 50% !important;"></v-img>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    components: {
      preview: () => import('../modals/PreviewPrePost'),
    },
    name: "ImageDetails",
    data: () => ({
      err: '',
      success: '',
      valid: false,
      isEdit: false,
      companyLoading: true,
      lablesLoading: false,
      companies: [],
      labels: [],
      images: [],
      filename:'',
      image: {
        "id": "",
        "name": "",
        "companyId": "",
        "base64Image": "",
        "label": "",
        "status": "",
        "createdOn": "",
        "createdBy": "",
        "modifiedOn": "",
        "modifiedBy": "",
        "publiclyAvailable": false
      },
      previewModal: false,
      previewData: null,
    }),
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    computed: {
    },
    methods: {
      preview() {
        this.previewModal = true;
      },
      previewValidation() {
        let valid = true;
        if (this.image.base64Image.length > 0) valid  = false;
        return valid;
      },
      getFormData(files) {
        return new Promise((resolve) => {
          let reader = new FileReader();
          reader.readAsDataURL(files[0]);
          reader.onload = function () {
            resolve(reader.result);
          };
          reader.onerror = function (error) {
            resolve(null);
          };
        });
      },
      startInput(name) {
        this.$refs[name].click();
      },
      async onFileChange(name, $event) {
        const files = $event.target.files || $event.dataTransfer.files
        if (files && files[0]) {
          const data = await this.getFormData(files);
          if (data === null) {
            this.err = 'Failed to convert image';
            return;
          }
          const maxSize = 786432;
          if (files[0].size > maxSize) {
            this.err = `The selected images is beyond limit of ${maxSize} KB.`
            this.filename = '';
            this.image.base64Image = '';
            return;
          }
          const img = new Image();
          img.src = window.URL.createObjectURL(files[0]);
          img.onload = () => {
            const width = img.naturalWidth;
            const height = img.naturalHeight;
            window.URL.revokeObjectURL( img.src );
            const maxWidth = 1920;
            const maxHeight = 1080;
            if( Number(width) > maxWidth || Number(height) > maxHeight ) {
              this.err = `The maximum allowed resolution is ${maxWidth} x ${maxHeight}.`
              this.filename = '';
              this.image.base64Image = '';
              return;
            }
            this.filename = files[0].name;
            this.image.base64Image = data;
          };
        } else {
          this.filename = '';
          this.image.base64Image = '';
        }
      },
      init() {
        return new Promise((resolve) => {
          this.$http.get('company')
            .then((res) => {
              resolve()
              this.companyLoading = false;
              if (res.body.status === 'Success') {
                this.companies = res.body.companies;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve()
              this.companyLoading = false;
              this.err = err.body.statusText || err.body.message;
            });
          const edit = this.$cookie.get('companyedit');
          if (edit) this.image.companyId = edit;
        });
      },
      toggleActivate() {
        const action = this.image.status === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`imageresource/${action}/${this.image.id}`)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.image.status = action === 'activate' ? 'active' : 'inactive';
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
      async fetchLables() {
        this.lablesLoading = true;
        this.labels = [];
        this.$http.get(`system/imageresource/fetchimageresourcelabels`)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.lablesLoading = false;
              this.labels = res.body.imageResourceLabels.sort();
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
      submit() {
        if (this.image.base64Image === '') {
          this.err = 'Please upload image to continue';
          return;
        }
        let url = this.isEdit ? `imageresource/update/${this.$route.params.id}` : 'imageresource/create';
        this.$http.post(url, this.image)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.success = this.isEdit ? 'Image updated successfuly' : 'Image created successfuly';
              setTimeout(() => {
                if (this.isEdit) {
                  this.success = '';
                } else {
                  this.$router.push({ name: 'images' });
                }
              }, 3000);
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
    },
    created() {
      this.fetchLables()
        .then(() => {
          this.init()
            .then(() => {
              if (this.$route.params.id) {
                this.isEdit = true;
                this.$http.get(`imageresource/${ this.$route.params.id }`)
                  .then((res) => {
                    if (res.body.status === 'Success') {
                      this.image = res.body.imageResource;
                      this.filename = res.body.imageResource.name;
                      return;
                    }
                    this.err = res.body.statusText
                  }, (err) => {
                    this.err = err.body.statusText || err.body.message;
                  })
              }
            })
        })
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ImageDetails.vue?21366384